<template>
  <div id="users-main"> 
  <v-container fluid ma-0 pa-0 px-4>
    <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  Users
                </h2>
              </template>
                <span>Users</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Users - <span class="font-weight-bold">{{total}}</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical ></v-divider>
          <v-flex shrink fill-height class="action">
            <v-tooltip left color="secondary">
              <v-btn
                icon
                flat
                slot="activator"
                class="new-user-button"
                @click="newUser()"
                >
                <v-icon color="success" size="24">add_circle</v-icon>
                  </v-btn>
                  <span>Create a new User</span>
                </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
        <v-layout wrap>
        <v-flex xs12 pt-1>
          <v-btn
            class="search-button ml-0 mb-2"
            :ripple="false" flat
            v-on:click="searchUsersToggled = !searchUsersToggled">
            <v-icon color="secondary" class="mr-2 mt-0">
              {{ searchUsersToggled ? 'close' : 'search' }}
            </v-icon>
            {{ searchUsersToggled ? 'Close search' : 'Search' }}
          </v-btn>
          <v-slide-y-transition>
            <v-layout row wrap class="mt-0" v-if="searchUsersToggled">
              <v-flex
                xs12 sm6 md4
                pt-1 :class="{'pr-0 ': $vuetify.breakpoint.xsAndDown, 'pr-2': $vuetify.breakpoint.smAndUp}">
                <v-text-field
                  box clearable
                  class="users-search-input cardcontainer-search-text pa-0 ma-0 body-1"
                  v-model="searchTerm"
                  label="Search"
                  color="secondary"
                  clear-icon="cancel">
                  <template slot="append">
                    <v-icon>search</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex
                xs12 sm6 md4
                pt-1 :class="{'pl-0': $vuetify.breakpoint.xsAndDown, 'pl-2': $vuetify.breakpoint.smAndUp}">
                <v-select
                  box clearable
                  style="border-bottom:0 !important; "
                  class="cardcontainer-order-select pa-0 ma-0 body-1"
                  :items="orderByOptions"
                  item-text="text"
                  item-value="value"
                  v-model="orderSelection"
                  @change="search()"
                  label="Order by"
                  color="secondary"
                  clear-icon="cancel"
                  append-icon="keyboard_arrow_down">
                </v-select>
              </v-flex>
            </v-layout>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap fluid class="card-margin-fix">
          <UserCard  v-for="(user, index) in orderedUsers" :key="index" :cardContent="user"></UserCard>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import '@/assets/styles/styles.css'
import { mapState } from 'vuex'
import UserCard from '@/components/Users/UserCard.vue'

export default {
  name: 'users',
  components: { UserCard },
  data: () => ({
    searchUsersToggled: false,
    orderByOptions: [{ text: "Name", value: "displayName" }, { text: "Last Login", value: "lastSeen" }, { text: "Date Created", value: "createdAt" }],
    orderSelection: undefined,
    searchByOptions: ["displayName", "email", "id"],
    searchTerm: "",
    localUserList: undefined
  }),
  computed: {
    ...mapState({
      users: state => state.users.all,
      isLoading: state => state.ui.loadingUsers
    }),
    orderedUsers: {
      get() {
        if (!this.localUserList) { this.search() }
        return this.localUserList
      },
      set(newlist) {
        this.localUserList = newlist
      }
    },
    total() {
      if (this.users && this.users.length > 0) {
        return this.users.length
      } else {
        return 0
      }
    }
  },
  watch: {
    searchTerm() { this.search() }
  },
  methods: {
    newUser() {
      this.$router.push("users/new")
    },
    search() { // And Sort
      let newList = this.users

      if (this.searchTerm) {
        newList = this.users.filter((user) => user.displayName.toLowerCase().includes(this.searchTerm.toLowerCase()))
      }

      if (this.orderSelection) {
        switch (this.orderSelection) {
          case "lastSeen":
            newList = this.orderByLastSeen(newList)
            break
          case "displayName":
            newList = this.orderByName(newList)
            break
          case "createdAt":
            newList = this.orderByCreation(newList)
            break
          default:
            break
        }
      }
      this.orderedUsers = newList
    },
    orderByLastSeen(users) {
      if (users && users.length > 0) {
        return users.sort(function (a, b) {
          if (a.lastSeen < b.lastSeen) { return -1 }
          if (a.lastSeen > b.lastSeen) { return 1 }
          return 0
        })
      }
      return []
    },
    orderByName(users) {
      if (users && users.length > 0) {
        return users.sort(function (a, b) {
          if (a.displayName < b.displayName) { return -1 }
          if (a.displayName > b.displayName) { return 1 }
          return 0
        })
      }
      return []
    },
    orderByCreation(users) {
      if (users && users.length > 0) {
        return users.sort(function (a, b) {
          if (a.id < b.id) { return -1 }
          if (a.id > b.id) { return 1 }
          return 0
        })
      }
      return []
    }
  }
}
</script>
